import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authorizeUser, selectAuthLoading } from '../../reducers/auth';
import styled from "styled-components";
import { environment_conf } from '../../../utilities/environment';

const StyledButton = styled.button`
  cursor: pointer;
  width: 95%;
  height: 40px;
  padding: 0px 15px;
  border-radius: 20px;
  border: 1px solid #ccc;
  background-color: rgb(12, 73, 120);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  white-space: normal;
  text-align: center;
  position: relative;
  transition: background-color 0.1s ease;
  &:hover {
    background-color: rgba(12, 73, 120, 0.8);
  }
  @media (max-width: 267px) {
    line-height: 1.2;
  }
`;

const DashboardLink = styled.a`
  color: rgb(12, 73, 120);
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: rgba(12, 73, 120, 0.8);
  }
`;

export const UserAlertComponent = () => {
    const isLoading = useSelector(selectAuthLoading);
    const dispatch = useDispatch<any>();
    const handleRefresh = () => {
        dispatch(authorizeUser());
    };

    return (
        <div style={{ padding: '4px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <p style={{ margin: '0 0 12px 0' }}>
                You've used all your tokens. Please visit the <DashboardLink href={`${environment_conf.base_app_domain}/dashboard`} target="_blank" rel="noopener noreferrer">dashboard</DashboardLink> to add more and continue enjoying our services.
            </p>
            <StyledButton
                onClick={handleRefresh}
                disabled={isLoading}
            >
                {isLoading ? 'Refreshing...' : 'Refresh'}
            </StyledButton>
        </div>
    );
}